import { makeStyles } from '@mui/styles';
import MenuItem from 'apollo-react/components/MenuItem';
import Select from 'apollo-react/components/Select';
import React from 'react';

import withTranslation from '../../../components/withTranslation';

const useStyles = makeStyles({
  formControlRoot: {
    width: 'auto',
    margin: 0,
    marginTop: 8,
    marginLeft: 3,
    '& > .MuiInputLabel-root': {
      display: 'none',
    },
  },
  selectRoot: {
    height: 16,
  },
  select: {
    border: 'none !important',
    fontSize: 16,
    fontWeight: '600 !important',
    lineHeight: 1.04,
    '&:focus': {
      boxShadow: 'none',
    },
  },
  menuPaper: {
    borderRadius: '0 0 4px 4px',
  },
});

const DashboardTabSelector = ({ tabs, value = 0, onChange, translateString, selectLabel = '' }) => {
  const classes = useStyles();

  function handleChange(e) {
    const { value } = e.target;
    if (onChange) {
      onChange(value);
    }
  }

  if (tabs.length < 2) {
    return null;
  }

  return (
    <Select
      canDeselect={false}
      label={selectLabel}
      className={classes.formControlRoot}
      SelectProps={{
        classes: {
          root: classes.selectRoot,
          select: classes.select,
          icon: classes.icon,
        },
        MenuProps: {
          classes: {
            paper: classes.menuPaper,
          },
        },
      }}
      value={value}
      onChange={handleChange}
    >
      {tabs.map((tab, index) => (
        <MenuItem key={tab.id} value={index}>
          <span>{translateString(tab.title)}</span>
        </MenuItem>
      ))}
    </Select>
  );
};

export default withTranslation(DashboardTabSelector);
